import { Command, MenuItemLeading, type SvgIcon } from "@pharaday/lighthouse";

import type { Command as DomainCommand } from "../index";

export type GenericCommandItemProps = DomainCommand & {
  Icon?: SvgIcon;
};

// The content of a palette row, which `Command.Item` already is: it lays these out as the row's leading, label and shortcut.
const GenericCommandItem = ({ Icon, ...command }: GenericCommandItemProps) => {
  return (
    <>
      {Icon && <MenuItemLeading leading={{ icon: Icon }} />}
      <span className="min-w-0 flex-1 break-words">{command.name}</span>
      {command.shortcut && <Command.Shortcut mainKey={command.shortcut.mainKey} subKey={command.shortcut.subKey} />}
    </>
  );
};

export default GenericCommandItem;
